<style>
    input[type='radio']{
        display: none;
    }
    label{
        display: table!important;
    }
    input[type='radio']:checked + label { color:rgb(109, 105, 105); font-weight: bold; }
    input[type='radio']:hover + label { color:rgb(156, 154, 154); font-weight: bold; }
</style>

<script> 

    import { onMount } from "svelte";

    import {  PostContact } from "../Services/form0";
    import { user } from "../store";
    import { createEventDispatcher } from 'svelte';
    import jsonata  from "jsonata";
    import { options } from "../config";
import { loading } from "../loader";
  

    const dispatch = createEventDispatcher();

    let customers = [];
    loading.set(true)
    export let customer=null

    onMount(() => {
        const data = {
            profile: options.profile,
            form: "customers",
        };
        PostContact(
            data,
            $user.idToken,
            (data) => {
                const y = jsonata("$^($uppercase(_source.customer))").evaluate(data.app_metadata.search.hits.hits)||[];
                if(Array.isArray(y))
                    customers = y
                else{
                    customers = []
                    customers.push(y)
                }
                loading.set(false)
            },
            (error) => {
                loading.set(false)
                console.error(error);
            }
        );
    });

    const dispatch_ = ()=>{
        
        if(customer){
            dispatch('customer',{
                customer:customer
            })
        }
    }
</script>

<h1>Customers <a href="#/customer/" class="edit">Add</a></h1>
    <table class="large_table">
    {#each customers as { _source }, i}
        <tr>
            <td class=" ">
                <a href="#/customer/{_source.contact_uuid}" class="edit"></a>
            </td>
            <td class=" ">
                <input type="radio" on:click={dispatch_} name="customer" id="{i}" value={_source.contact_uuid} bind:group={customer}>
                <label for="{i}">{_source.customer}</label> 
            </td>
        </tr>
        
           
    {/each}
 
</table>